import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-setcustomer',
  templateUrl: './setcustomer.component.html',
  styleUrls: ['./setcustomer.component.css']
})
export class SetcustomerComponent implements OnInit {
  ViewSTB: any = {};	
  registerForm: FormGroup;


  constructor(
  	private route: ActivatedRoute,
	  private router: Router,
	  public partnerService: ApiPartnerService,
	  private formBuilder: FormBuilder) { }

  ngOnInit() {
  	let id = this.route.snapshot.paramMap.get('id');
  	this.loadCustomer(id);
  	this.registerForm = this.formBuilder.group({
            nama: ['', Validators.required],
            alamat: ['', Validators.required],
            telp: ['', Validators.required],
            email: ['', Validators.required],
            tipe: ['', Validators.required],
            notes: ['', Validators.required]
        }, {
           
        });

  	
  }

  loadCustomer(id: any) {
    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
    console.log(output);
     	this.ViewSTB = output.data;
    })
  }

  submit()
  {
  	let data = this.registerForm.value;

  	
  	data.snstb = this.ViewSTB.sn;
    data.partnerid = this.ViewSTB.partnerid;
  	return this.partnerService.PostCustomer(data).subscribe((output: any) => {
    console.log(output);
      //this.loadServices(this.customerid);
      if ( output['status'] ){
      	this.router.navigate(['/manage'], { queryParams: { returnUrl: '/manage' } });
      } else {
      	alert(output['message']);
      }

    })
  	alert('OKE');
  }
}
